package org.testadirapa.cardtrader

import kotlinx.serialization.Serializable

@Serializable
data class Url(
	val url: String,
)